import * as tailwindColors from 'tailwindcss/colors'

export const availableColors = {
  ...tailwindColors,
}
